import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getUsuarioDetalle, postUpdatePasswordUser } from "../../../api/ApiService";


function ResetUsuarioPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [dataUsuario, setDataUsuario] = useState(null);

    const [perPage, setPerPage] = useState(5);


    const stateToken = useSelector(state => state.reducerGlobal.token);
    const navigate = useNavigate();


    const params = useParams();

    const { id } = params;
    // console.log("id", id);


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleUsuarioDetalle();
            }
        }
    }, [id, stateToken, perPage]);



    //==========================================================funcion para enviar encuesta a la api
    const handleUsuarioDetalle = (pageToLoad = 1, perPageToLoad = perPage) => {
        let body = {
            id: id,
            canjes_per_page: perPageToLoad,
            canjes_page: pageToLoad
        }


        getUsuarioDetalle(stateToken?.access_token, body)
            .then(response => {
                // console.log("getUsuarioDetalle", response);
                setCargando(true);
                setLoading(false);

                setDataUsuario(response?.data?.usuario || null);


            })
            .catch(error => {
                console.log("error-getUsuarioDetalle", error);
                setLoading(false);
                setCargando(true);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }

    //==========================================================funcion para enviar encuesta a la api
    const handleUpdatePassword = () => {
        let body = {
            password: password,
            password_confirmation: passwordConfirm
        }

        //validar que las contraseñas coincidan
        if (password !== passwordConfirm) {
            setMensaje("Las contraseñas no coinciden");
            setSeverity('error');
            setOpen(true);
            return;
        }

        console.log("body", body);



        setLoading(true);
        postUpdatePasswordUser(stateToken?.access_token, body, id)
            .then(response => {
                console.log("postUpdatePasswordUser", response);
                setLoading(false);

                setMensaje("Contraseña actualizada correctamente");
                setSeverity('success');
                setOpen(true);

                //limpiar campos
                setPassword("");
                setPasswordConfirm("");

                setTimeout(() => {
                    navigate(-1);
                }, 1500);
            })
            .catch(error => {
                console.log("error-postUpdatePasswordUser", error);
                setLoading(false);

                setMensaje("Error al actualizar la contraseña");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    const handleVolver = () => {
        navigate(-1);
    };




















    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            Actualizar contraseña
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl border border-gray-200 p-6 sm:p-7">
                            <div className="mb-6 border-b border-gray-100 pb-4">
                                <h2 className="text-lg font-semibold text-gray-800">
                                    Ingrese la nueva contraseña
                                </h2>
                                <p className="text-sm text-gray-500 mt-1">
                                    Complete el formulario para actualizar la contraseña del usuario.
                                </p>
                            </div>

                            <div className="mb-6 rounded-xl border border-gray-200 bg-[#f8fafc] p-4">
                                <h3 className="text-sm font-semibold text-gray-800 mb-3">Datos del usuario</h3>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    <div>
                                        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Nombre</p>
                                        <p className="text-sm text-gray-800 mt-0.5">
                                            {`${dataUsuario?.user?.first_name || ""} ${dataUsuario?.user?.last_name || ""}`.trim() || "-"}
                                        </p>
                                    </div>

                                    <div>
                                        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Cédula</p>
                                        <p className="text-sm text-gray-800 mt-0.5">{dataUsuario?.ci || "-"}</p>
                                    </div>

                                    <div>
                                        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Email</p>
                                        <p className="text-sm text-gray-800 mt-0.5 break-all">{dataUsuario?.user?.email || "-"}</p>
                                    </div>

                                    <div>
                                        <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">Teléfono</p>
                                        <p className="text-sm text-gray-800 mt-0.5">{dataUsuario?.numero_telefono || "-"}</p>
                                    </div>
                                </div>
                            </div>

                            <form onSubmit={(e) => {
                                e.preventDefault();
                                handleUpdatePassword();
                            }} className="space-y-6">
                                <div>
                                    <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-1.5">
                                        Nueva contraseña
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="passwordConfirm" className="block text-sm font-semibold text-gray-700 mb-1.5">
                                        Confirmar nueva contraseña
                                    </label>
                                    <input
                                        type="password"
                                        id="passwordConfirm"
                                        value={passwordConfirm}
                                        onChange={(e) => setPasswordConfirm(e.target.value)}
                                        required
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>

                                <div className="flex flex-wrap items-center gap-3 pt-2">
                                    <button
                                        type="submit"
                                        className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] text-white rounded-lg font-medium transition-colors"
                                        disabled={loading}
                                    >
                                        {/* Actualizar contraseña */}
                                        {loading ? "Actualizando..." : "Actualizar contraseña"}
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleVolver}
                                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                                    >
                                        Volver
                                    </button>
                                </div>
                            </form>

                        </div>
                    ) :
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Backdrop open={loading} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default ResetUsuarioPage;